import {
    createContext,
    useContext,
} from "react";

export interface User {
    id: string;
    email: string;
    name: string | null;
    picture: string | null;
    role: string;
}

export interface AuthContextType {
    user: User | null;
    setUser: (user: User | null) => void;
    token: string | null;
    setToken: (token: string | null) => void;
    currentDietId: string | null;
    setCurrentDietId: (dietId: string | null) => void;
    selectedDietType: string | null;
    setSelectedDietType: (dietType: string | null) => void;
    isAuthenticated: boolean;
    isAdmin: boolean;
    authFetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth() {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
}
